import store from "@/store";

export default async function ({ to, next }) {
  const getCan = store.getters["acl/GetCan"];
  if (getCan(to.meta.permission)) {
    next();
  } else {
    next({ name: "Home" });
  }
}
